import React from "react";
import EmptyState from "../../component/emptyState";
import ProfileMenu from "../../layout/appLayout/profileMenu";
import HamburgerButton from "../../layout/appLayout/hamburgerButton";
import Sidebar from "../../layout/appLayout/sidebar";

export default function BlankPage() {
  return (
    <div className="fixed w-full h-full top-0 xl:w-[calc(100%-278px)] right-0 z-[200]">
      <div className="w-full px-[15px] pt-2">
        <HamburgerButton
          view={<Sidebar className="static w-full 2xl:w-full" />}
          className="text-primary-dark"
          placement="left"
          containerClassName="!w-[278px]"
        />
        <div className="absolute right-[15px] top-[8px]">
          <ProfileMenu />
        </div>
      </div>
      <div className="h-full w-full justify-center flex flex-row items-center">
        <EmptyState
          heading="No activities yet"
          subHeading="Create a new campaign or use our demo campaign to experience how ringconnect works"
        />
      </div>
    </div>
  );
}
